import http from "../http";

export default {
  indexChampTeams(edition_modality_id) {
    return http.plainAxiosInstance.get(
      `/championships/${edition_modality_id}/champ_teams`
    );
  },

  showChampTeam(edition_modality_id, champ_team_id) {
    return http.plainAxiosInstance.get(
      `/championships/${edition_modality_id}/champ_teams/${champ_team_id}`
    );
  },

  updateChampTeam(champTeam) {
    const {
      id,
      group,
      games_played,
      points,
      won,
      draw,
      lost,
      goals_scored,
      goals_against,
      goals_difference,
      red_card,
      yellow_card,
      edition_modality_id,
      team_attributes
    } = champTeam;
    return http.plainAxiosInstance.put(`/champ_teams/${id}`, {
      champ_team: {
        id,
        group,
        games_played,
        points,
        won,
        draw,
        lost,
        goals_scored,
        goals_against,
        goals_difference,
        red_card,
        yellow_card,
        edition_modality_id,
        team_attributes
      }
    });
  },

  //------------------------------------------------------------

  indexGroupConfiguration(edition_modality_id) {
    return http.plainAxiosInstance.get(
      `/championships/${edition_modality_id}/group_configurations`
    );
  }
};
